import { Component, OnInit, HostListener,PLATFORM_ID,Inject } from '@angular/core';
import { WebsiteService } from 'src/app/_services/website.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import * as $ from 'jquery';
import { Router } from '@angular/router';
import { LoadScriptService } from 'src/app/_services/load-script.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
declare function ire(string,{}): any;
@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {
  contactForm: FormGroup;
  disabledSubmitButton: boolean = true;
  country: string;
  isSubmitting: boolean = false;
  @HostListener('input') oninput() {

    if (this.contactForm.valid) {
      this.disabledSubmitButton = false;
      }
    }

  constructor(
    private fb: FormBuilder,
    private networkCall: WebsiteService, 
    private toastr: ToastrService,
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    private router: Router,
    public loadScript: LoadScriptService,
    private http: HttpClient
    // private shareService: SharedService
    
  ) {
    this.contactForm = fb.group({
      'contactFormName': ['', Validators.required],
      'contactFormEmail': ['', Validators.compose([Validators.required, Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)])],
      'contactFormContactNumber': ['', Validators.required],
      'contactFormOrgTitle': ['', Validators.required],
      'contactFormMessage': ['', Validators.required]
      // 'contactFormCopy': [''],
    });
  }

  ngOnInit() {
    ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()})
    // this.contactForm = this.fb.group({
    //   contactFormEmail: new FormControl('', [Validators.required, ]),
    // })
    this.titleService.setTitle('Entre em contato | Trinka');
    this.metaTagService.updateTag({ name: 'description', content: 'Corrija instantaneamente sua escrita em inglês com a ajuda desta ferramenta de verificação gramática gratuita e eficiente. Com a Trinka, escrever é agora livre de estresse. Comece a escrever com a Trinka!' });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Entre em contato | Trinka' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'Corrija instantaneamente sua escrita em inglês com a ajuda desta ferramenta de verificação gramática gratuita e eficiente. Com Trinka, escrever é agora livre de estresse. Comece a escrever com Trinka!' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/pt/contactus' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'pt-pt' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/pt/contactus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/contactus'});
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/contactus'});
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/contactus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/contactus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/contactus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/contactus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/contactus' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/contactus' });
    if (isPlatformBrowser(this.platformId)){
      $.getScript('../../../assets/js/about_us_testimonial_silders.js', function () { });
      $.getScript('../../../assets/js/wisepop.js', function(){});
    }
  }

  processForm() {

    if (this.contactForm.valid) {
      this.isSubmitting = true;

      if (!localStorage.getItem("country-trinka")) {
          this.loadGeoAPIScript();
      }

      this.country = localStorage.getItem("country-trinka") || "IN";

      const organizationName = this.contactForm.value.contactFormOrgTitle || "Unknown Organization";
      const personName = this.contactForm.value.contactFormName;
      const email = this.contactForm.value.contactFormEmail;
      const phone = this.contactForm.value.contactFormContactNumber;
      const comments = `Requirement - ${this.contactForm.value.contactFormMessage || ""}
        URL - ${this.router.url || "N/A"}`;

      console.log("comments are:", comments);

      //const selectedInquiryType = this.contactForm.value.contactFormInquiryType;
      // Create the subject with the selected inquiry type
      //const subject = `Inquiry Type: ${selectedInquiryType}`;
      var query = this.contactForm.value.contactFormName + "||" + this.contactForm.value.contactFormMessage + "||" + this.contactForm.value.contactFormContactNumber + "||" + this.contactForm.value.contactFormOrgTitle
      this.networkCall.postContactUs(this.contactForm.value.contactFormEmail, query, this.router.url).subscribe(result => {
        this.toastr.success("Obrigado! Nós entraremos em contato com você em breve.")
        this.contactForm.reset();
        //this.billingInvoiceText = false;
      }, error => {
        this.toastr.warning("Something went wrong!")
      }).add(() => {
        this.isSubmitting = false;
      });
    } else {
        this.validateAllFormFields(this.contactForm);
    }
    // const allInfo = `My name is ${this.name}. My email is ${this.email}. My message is ${this.message}`;
    // alert(allInfo);
  }


  loadGeoAPIScript() {
    if (isPlatformBrowser(this.platformId)) {
      var scriptName = "geoIP"
      this.loadScript.loadScript(scriptName, '//geoip-js.com/js/apis/geoip2/v2.1/geoip2.js')
        .then(() => {
          console.log(`${scriptName} loaded successfully`);
          var onSuccess = function (location) {
            localStorage.setItem("country-trinka", location['country']['iso_code'])
          };

          var onError = function (error) {
            localStorage.setItem("country-trinka", "IN")
          };
          try {
            //@ts-ignore
            geoip2.city(onSuccess, onError);
          } catch (error) {
            console.log(error)
          }
        })
        .catch(() => {
          console.error(`Failed to load ${scriptName}`);
        });
    }
  }


  validateAllFormFields(formGroup: FormGroup){
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }

  generateGuid() {
    var result, i, j;
    result = '';
    for(j=0; j<32; j++) {
      if( j == 8 || j == 12 || j == 16 || j == 20)
        result = result + '-';
      i = Math.floor(Math.random()*16).toString(16).toUpperCase();
      result = result + i;
    }
    return result;
  }

}
